/* eslint-disable react/no-danger */
/* eslint-disable no-confusing-arrow */
import DOMPurify from 'dompurify';
import React, { useMemo } from 'react';
import DataTable from 'src/shared/components/DataTable';
import styled from 'styled-components';

const Wrapper = styled.div`
  .ant-table-row {
    .ant-table-cell {
      padding: 8px 16px;
    }

    &:nth-child(odd) {
      .ant-table-cell {
        background-color: var(--title-backgournd-grey);
      }
    }
  }
`;

function BookDetailContent({ contentList = [] }) {
  const columns = [
    {
      title: 'Thông tin',
      dataIndex: 'Title',
      key: 'Title',
    },
    {
      title: 'Chi tiết',
      dataIndex: 'Value',
      key: 'Value',
      render: (value) => (
        <div
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value[0]) }}
        />
      ),
    },
  ];

  // const [availableContent, setAvailabelContent] = useState([]);

  const availableContent = useMemo(
    () => contentList.filter((item) => item.Title),
    [contentList]
  );

  return (
    <Wrapper>
      <DataTable
        dataSource={availableContent}
        columns={columns}
        pagination={false}
      />
    </Wrapper>
  );
}

export default BookDetailContent;
